<template>
  <el-dialog
    title="Select visibility condition"
    width="600px"
    :before-close="handleCancel"
    :visible.sync="isVisible"
    v-if="currentQuestion"
  >
    <p class="help-description">
      Only display the question
      <strong>"{{ currentQuestion.title }}"</strong>, once the user has selected a specific choice
      from one of the following questions.
    </p>
    <div v-for="question in availableQuestions" :key="question.id" class="question-item">
      <div class="title">{{ question.title }}</div>
      <el-checkbox-group size="mini" v-model="visibilityCondition">
        <span>
          <el-checkbox-button
            v-for="choice in question.choices"
            :key="choice.id"
            :label="getLabel(question, choice)"
            >{{ choice.title }}</el-checkbox-button
          >
        </span>
      </el-checkbox-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="pull-left"
        :disabled="!currentQuestion"
        @click="handleRemoveLinks"
        type="danger"
        >Remove condition</el-button
      >
      <el-button @click="handleCancel">Cancel</el-button>
      <el-button type="primary" @click="handleSave">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

export default {
  name: 'ConditionalLogicDialog',
  data: () => ({
    selectedChoice: null,
    selectedQuestion: null,
  }),
  computed: {
    ...mapState('surveybuilder', ['canvasQuestions', 'survey']),

    isVisible: {
      get() {
        return this.$store.state.surveybuilder.questionConditionalLogicDialogVisible;
      },
      set(value) {
        this.$store.commit(
          `surveybuilder/${surveyBuilderTypes.SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY}`,
          value,
        );
      },
    },

    visibilityCondition: {
      get() {
        return this.currentQuestion.visibilityCondition.split(' or ').filter(c => c !== '');
      },

      set(conditions) {
        this.currentQuestion.visibilityCondition = conditions.filter(c => c !== '').join(' or ');
      },
    },

    availableQuestions() {
      const questionTypes = ['SELECT', 'SCALE', 'MULTI_SELECT', 'RADIOGROUP'];
      return this.canvasQuestions.filter(
        q => q.id !== this.currentQuestion.id && questionTypes.includes(q.questionType),
      );
    },

    currentQuestion: {
      get() {
        return (
          this.selectedQuestion ||
          this.$store.state.surveybuilder.questionConditionalLogicDialogQuestion
        );
      },
      set(value) {
        this.selectedQuestion = value;
      },
    },
  },
  methods: {
    handleRemoveLinks() {
      this.currentQuestion.visibilityCondition = '';
    },
    handleCancel() {
      this.isVisible = false;
    },
    handleSave() {
      const updatedQuestions = this.canvasQuestions.map(q => {
        if (q.id !== this.currentQuestion.id) {
          return q;
        }
        return this.currentQuestion;
      });

      this.$store
        .dispatch('surveybuilder/updateQuestions', {
          questions: updatedQuestions,
          surveyId: this.survey.id,
        })
        .then(() => {
          this.isVisible = false;
        });
    },
    getLabel(question, choice) {
      const questionType = question.questionType;
      const defaultCondition = `{question${question.id}}='${choice.title}'`;
      const multiSelectCondition = `{question${question.id}} contains '${choice.title}'`;
      return questionType === 'MULTI_SELECT' ? multiSelectCondition : defaultCondition;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/_variables_live.scss';
.help-description {
  color: darken($colony-light-gray, 35%);

  strong {
    color: black;
  }
}
.question-item {
  width: 100%;
  margin-bottom: 4px;
  padding: 8px;
  border-radius: 3px;
  background-color: lighten($colony-light-gray, 5%);
  cursor: grab;

  .title {
    font-size: 1.2em;
    margin-bottom: 0.4em;
  }
}
</style>



// WEBPACK FOOTER //
// QuestionConditionalLogicDialog.vue?f8b8b410